import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { jsonpCallbackContext } from '@angular/common/http/src/module';

@Injectable()
export class BraintreeDropinService {

  constructor(private http: BaseService) { }

  getClientToken(clientTokenURL: string): Observable<any> {
    return this.http.get(clientTokenURL);
  }

  createPurchase(createPurchaseURL: string, paymentRequestObj: any): Observable<any> {
    return this.http.post(createPurchaseURL, JSON.stringify(paymentRequestObj));
  }

  configureCardHolderName(dropinConfig): void {
    dropinConfig.card = {
      cardholderName: {
        required: true
      }
    }
  }

  configurePaypalCheckout(dropinConfig, chargeAmount, currency): void {
    dropinConfig.paypal = {
      flow: 'checkout',
      amount: chargeAmount,
      currency: currency
    }
  }

  configurePaypalVault(dropinConfig) {
    dropinConfig.paypal = {
      flow: 'vault'
    }
  }

  configureLocale(dropinConfig, locale) {
    dropinConfig.locale = locale;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/braintree-dropin.service.ts